export type UserType = 'farmer' | 'specialist';

export enum CallStatusType {
	Missed = 'missed',
	Incoming = 'incoming',
	Outgouing = 'outgoing',
}

export enum ChatTabType {
	Direct = 'direct',
	Groups = 'groups',
	Completed = 'completed',
	Calls = 'calls',
}

export enum ChannelType {
	DirectMessaging = 0,
	DirectReadonly = 1,
	GroupMessaging = 2,
	ChannelMessaging = 3,
	FarmerSupportMessaging = 4,
	SpecialistSupportMessaging = 5,
	TelagriNewsSpecialistChannel = 6,
	TelagriNewsFarmerChannel = 7,
}

export enum MessageType {
	Text = 'text',
	Audio = 'audio',
	Deleted = 'deleted',
	Edited = 'edited',
}

export enum MessageSendStatus {
	Sent,
	Sending,
	Failed,
}

export enum MessageStatus {
	Active,
	Deleted,
	Edited,
}

export enum OnlineStatus {
	Offline,
	Online,
}

export type ChatUsersHashSet = {
	[userId: string]: ChatUser;
};

export interface ChatUser {
	id: string;
	name: string;
	surname: string;
	avatar: string;
}

export interface ChatUserWithOnlineStatus extends ChatUser {
	onlineStatus: OnlineStatus;
}
